// src/Layout/Content.js
import React, { Component } from "react"
import { Routes, Route } from "react-router-dom"
import { graphql } from '@apollo/client/react/hoc'
import '../App.css'
import AttributeContainer from '../Attributes/AttributeContainer'
import AttributeIndexContainer from '../Attributes/AttributeIndexContainer'
import ArgyleUserListContainer from '../Argyle/ArgyleUserListContainer'
import AutomatelyContainer from '../Automately/AutomatelyContainer'
import AvailableCars from '../CA/AvailableCars/AvailableCarsContainer'
import AuditListContainer from '../Audit/AuditList/AuditListContainer'
import BranchDetailWrapper from '../Organization/BranchMangement/BranchDetailWrapper'
import CarReturnListContainer from '../CarReturn/CarReturnListContainer'
import CarDetailContainerWrapper from '../Cars/CarDetailNew/CarDetailContainerWrapper'
import CollectionsViews from '../Drivers/Collections/CollectionListViews'
import CollectionsDashboard from '../Drivers/Collections/CollectionsDashboard/CollectionsDashboard'
import PaymentPlanListContainer from '../Drivers/Collections/PaymentPlanListContainer'
import ChatBotContainer from '../ChatBot/ChatBotContainer'
import CarIssueRedirect from '../CarIssues/CarIssueRedirect'
import ClaimsPage from '../Incidents/ClaimsPage'
import DriverListContainerNew from '../Drivers/DriversNew/DriversListContainer'
import DriverDetailContainerWrapper from '../Drivers/Driver/Detail/DetailsNew/DriverDetailContainerNewWrapper.js'
import FleetManagement from '../CA/FleetManagement/FleetManagementContainer'
import FollowupCustomersContainer from '../FollowupCustomers/FollowupCustomersContainer'
import GroupsDetailsWrapper from '../Organization/GroupsManagement/GroupsDetailsWrapper'
import LeadsListContainerNew from '../CustomerLeads/LeadsListContainer'
import Login from '../Auth/Login'
import InteractionsContainer from '../Drivers/Interactions/InteractionsContainer'
import InsuranceListContainer from '../Insurances/InsuranceListContainer.js'
import IncidentsListContainer from "../Incidents/IncidentsListContainer.js"
import LiabilityClaimRedirect from "../Incidents/LiabilityClaimRedirect.js"
import SubrogationClaimRedirect from "../Incidents/SubrogationClaimRedirect.js"
import IncidentDetailContainerWrapper from "../Incidents/IncidentDetailContainerWrapper.js"
import MaintenancePage from '../Maintenance/MaintenancePage'
import MemberDetailsWrapper from '../Organization/MembersManagement/MemberDetailsWrapper'
import NotificationTemplatesListContainer from '../NotificationTemplates/NotificationTemplatesContainer'
import OrganizationPage from '../Organization/OrganizationPage'
import Page404 from '../Components/Page404'
import PermissionDetailsWrapper from '../Organization/PermissionsManagement/PermissionDetailsWrapper'
import PricingPromotionsPage from '../PriceManagement/PricingPromotionsPage'
import PaymentSchedulesListContainer from '../Billing/PaymentSchedules/PaymentSchedulesListContainer'
import RentalsListContainer from '../Rentals/RentalListNew/RentalsListContainer'
import RegistrationsContainer from '../RegistrationManagement/RegistrationsContainer'
import ReservationsPage from '../ReservationsNew/ReservationsPage'
import SubscriptionsContainer from '../Drivers/Subscriptions/SubscriptionsContainer'
import TenantDetailsWrapper from '../Organization/TenantManagement/TenantDetailsWrapper'
import TaskManagementContainer from '../TaskManagement/TaskManagementContainer'
import TPAPage from '../ThirdPartyAdministrator/TPAPage'
import UserDetailContainer from '../User/UserDetailContainer'
import { UserQuery } from '../Functions/querys'
import UploadsContainer from '../Uploads/UploadsContainer'
import withApolloClient from '../withApolloClient'
import CommsContainer from "../Communication/CommsContainer.js"
import CommsAdminContainer from "../Communication/Admin/CommsAdminContainer.js"
import DashboardContainer from "../Dashboard/DashboardContainer.js"


class Content extends Component {
    render() {
        const { loading, currentUser } = this.props
        if (loading && !currentUser) return <div></div>
        if (!currentUser && !loading) {
            return (
                <Routes>
                    <Route path="/login/" element={<Login />} />
                    <Route path="*" element={<Login />} />
                </Routes>
            )
        }

        if (currentUser) {
            return (
                <Routes>
                    <Route exact path="/" element={<DriverListContainerNew key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/automations/*" element={<AutomatelyContainer key={String(this.props.keyVersion)} currentUser={currentUser} client={this.props.apolloClient} />} />
                    <Route exact path="/boards/tasks/*" element={<TaskManagementContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/boards/:boardId/tasks/*" element={<TaskManagementContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/customers/followup" element={<FollowupCustomersContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/customers/leads" element={<LeadsListContainerNew key={String(this.props.keyVersion)} currentUser={currentUser} viewType="leadView" />} />
                    <Route exact path="/customers/applications" element={<LeadsListContainerNew key={String(this.props.keyVersion)} currentUser={currentUser} viewType="applicationView" />} />
                    <Route exact path="/customers/insurance/" element={<InsuranceListContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/customers/collections/" element={<CollectionsViews key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/customers/collections/spine/" element={<CollectionsDashboard key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/customers/scheduled_payments/" element={<PaymentSchedulesListContainer key={String(this.props.keyVersion)} currentUser={currentUser} navigate={this.props.navigate} location={this.props.location} />} />
                    <Route exact path="/customers/payment_plans/" element={<PaymentPlanListContainer key={String(this.props.keyVersion)} currentUser={currentUser} location={this.props.location} history={this.props.navigate} />} />
                    <Route exact path="/customers/subscriptions" element={<SubscriptionsContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/driver/:id" element={<DriverDetailContainerWrapper key={String(this.props.keyVersion)} currentUser={this.props.currentUser} />} />
                    <Route exact path="/customers/interaction" element={<InteractionsContainer key={String(this.props.keyVersion)} currentUser={currentUser} interactionsType="allDrivers" />} />
                    <Route exact path="/customers/argyle" element={<ArgyleUserListContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />

                    <Route exact path="/auditlog/" element={<AuditListContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />

                    <Route exact path="/incidents/" element={<IncidentsListContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/incidents/claims/" element={<ClaimsPage key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/liability-claims/:id" element={<LiabilityClaimRedirect />} />
                    <Route exact path="/subrogation-claims/:id" element={<SubrogationClaimRedirect />} />
                    <Route exact path="/incident/:id" element={<IncidentDetailContainerWrapper key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/tpa/" element={<TPAPage key={String(this.props.keyVersion)} currentUser={currentUser} />} />

                    <Route exact path="/maintenance/" element={<MaintenancePage key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/car-issues/:id" element={<CarIssueRedirect />} />

                    <Route exact path="/attribute/" element={<AttributeIndexContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/attribute/:name" element={<AttributeContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />

                    <Route path="/car/" element={<FleetManagement key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route path="/car/available/" element={<AvailableCars key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route path="/car/pricing/" element={<PricingPromotionsPage key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route path="/car/registrations/" element={<RegistrationsContainer key={String(this.props.keyVersion)} currentUser={currentUser} type="car" />} />
                    <Route path="/car/inspections/" element={<RegistrationsContainer key={String(this.props.keyVersion)} currentUser={currentUser} type="car" isInspectionView />} />
                    <Route exact path="/car/:pk" element={<CarDetailContainerWrapper key={String(this.props.keyVersion)} currentUser={currentUser} />} />

                    <Route exact path="/reservation/" element={<ReservationsPage key={String(this.props.keyVersion)} currentUser={currentUser} />} />

                    <Route exact path="/carreturn/" element={<CarReturnListContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/rental/" element={<RentalsListContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />

                    <Route exact path="/organization/" element={<OrganizationPage key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/organization/branch/:id" element={<BranchDetailWrapper key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/organization/tenant/:id" element={<TenantDetailsWrapper key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/organization/permission/:id" element={<PermissionDetailsWrapper key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/organization/group/:id" element={<GroupsDetailsWrapper key={String(this.props.keyVersion)} currentUser={currentUser} />} />
                    <Route exact path="/organization/member/:id" element={<MemberDetailsWrapper key={String(this.props.keyVersion)} currentUser={currentUser} />} />

                    <Route exact path="/uploads/" element={<UploadsContainer key={String(this.props.keyVersion)} />} />

                    <Route exact path="/user/" element={<UserDetailContainer key={String(this.props.keyVersion)} />} />
                    <Route path="/chatbot" element={<ChatBotContainer key={String(this.props.keyVersion)} currentUser={this.props.currentUser} />} />
                    <Route path="/chatbot/:sessionId" element={<ChatBotContainer key={String(this.props.keyVersion)} currentUser={this.props.currentUser} />} />
                    <Route exact path="/notification_templates/" element={<NotificationTemplatesListContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />

                    <Route exact path="/dashboard" element={<DashboardContainer key={String(this.props.keyVersion)} currentUser={currentUser} />} />

                    <Route path="/comms" element={<CommsContainer />} />
                    <Route path="/comms/conversation/:conversationId" element={<CommsContainer />} />
                    <Route path="/comms/admin" element={<CommsAdminContainer />} />
                    <Route path="/comms/admin/:tabName" element={<CommsAdminContainer />} />
                    <Route path="*" element={<Page404 />} />
                </Routes>
            )
        }

        return null
    }
}

export default graphql(UserQuery, {
    options: () => ({
        fetchPolicy: "cache-and-network",
    }),
    props: ({ data: { currentUser, loading, variables, refetch } }) => ({
        currentUser,
        loading,
        variables,
        refetchUserQuery: () => {
            return refetch({
                query: UserQuery,
                variables: {
                    ...variables,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    return { currentUser: fetchMoreResult.currentUser }
                },
            })
        },
    }),
})(withApolloClient(Content))
